if (!customElements.get('py-art-comparison')) {
  customElements.define('py-art-comparison', class extends HTMLElement {
    connectedCallback() {
      const range = this.querySelector('input[type="range"]');
      if (!range || this.onCompare) return;
      this.onCompare = () => this.style.setProperty('--art-position', `${range.value}%`);
      this.stopIntro = () => {
        if (this.introAnimations) {
          const divider = this.querySelector('.py-art-comparison__divider');
          range.value = parseFloat(getComputedStyle(divider).left) / this.clientWidth * 100;
          this.introAnimations.forEach(animation => animation.cancel());
          this.introAnimations = null;
          this.onCompare();
        }
        this.observer?.disconnect(); this.introDone = true;
      };
      this.beginAdjust = () => { this.stopIntro(); this.classList.add('is-adjusting'); };
      this.endAdjust = () => this.classList.remove('is-adjusting');
      this.onAdjustKey = event => {
        if (['ArrowLeft','ArrowRight','ArrowUp','ArrowDown','Home','End','PageUp','PageDown'].includes(event.key)) this.beginAdjust();
      };
      window.addEventListener('pointerup', this.endAdjust);
      window.addEventListener('pointercancel', this.endAdjust);
      range.addEventListener('blur', this.endAdjust);
      range.addEventListener('keyup', this.endAdjust);
      range.addEventListener('input', this.onCompare);
      range.addEventListener('pointerdown', this.beginAdjust);
      range.addEventListener('keydown', this.onAdjustKey);
      /* 真ん中のつまみをドラッグしたときだけ動かす（画像のどこかをタップしても動かない。2026-10-31）
         range は透明のまま残すのでキーボード操作はそのまま使える */
      const handle = this.querySelector('.py-art-comparison__handle');
      if (handle) {
        const moveTo = event => {
          const rect = this.getBoundingClientRect();
          const percent = Math.min(100, Math.max(0, (event.clientX - rect.left) / rect.width * 100));
          range.value = percent;
          this.onCompare();
        };
        this.onHandleDown = event => {
          event.preventDefault();
          this.beginAdjust();
          handle.setPointerCapture?.(event.pointerId);
          const move = e => moveTo(e);
          const up = () => {
            handle.removeEventListener('pointermove', move);
            handle.removeEventListener('pointerup', up);
            handle.removeEventListener('pointercancel', up);
            this.endAdjust();
          };
          handle.addEventListener('pointermove', move);
          handle.addEventListener('pointerup', up);
          handle.addEventListener('pointercancel', up);
        };
        handle.addEventListener('pointerdown', this.onHandleDown);
      }
      this.onCompare();
      if (!this.introDone) {
        this.observer = new IntersectionObserver(entries => {
          if (!entries.some(entry => entry.isIntersecting)) return;
          this.observer.disconnect();
          this.introDone = true;
          if (matchMedia('(prefers-reduced-motion: reduce)').matches) {
            range.value = 50; this.onCompare(); return;
          }
          const radius = parseFloat(getComputedStyle(this).getPropertyValue('--art-handle-radius')) || 24;
          const duration = 1300;
          const options = {duration, easing:'cubic-bezier(.25,.1,.25,1)', fill:'forwards'};
          const before = this.querySelector('.py-art-comparison__before');
          const divider = this.querySelector('.py-art-comparison__divider');
          const animations = [
            before.animate([{clipPath:`inset(0 ${radius}px 0 0)`},{clipPath:'inset(0 50% 0 0)'}], options),
            divider.animate([{left:`calc(100% - ${radius}px)`},{left:'50%'}], options)
          ];
          this.introAnimations = animations;
          Promise.all(animations.map(animation => animation.finished)).then(() => {
            if (this.introAnimations !== animations) return;
            range.value = 50;
            this.onCompare();
            animations.forEach(animation => animation.cancel());
            this.introAnimations = null;
          }).catch(() => {});
        }, {threshold:.35});
        this.observer.observe(this);
      }
    }
    disconnectedCallback() {
      this.stopIntro?.();
      this.observer?.disconnect();
      const range = this.querySelector('input');
      range?.removeEventListener('input', this.onCompare);
      range?.removeEventListener('pointerdown', this.beginAdjust);
      range?.removeEventListener('keydown', this.onAdjustKey);
      window.removeEventListener('pointerup', this.endAdjust);
      window.removeEventListener('pointercancel', this.endAdjust);
      range?.removeEventListener('blur', this.endAdjust);
      range?.removeEventListener('keyup', this.endAdjust);
      this.classList.remove('is-adjusting');
      this.onCompare = null;
    }
  });
}
